module.exports = __webpack_public_path__ + "assets/img/wxtu_20240103161550_43.a33b190a.png";